import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { currentAppScope } from '../../core/scope/app-scope';
import { WizardApiService } from './wizard-api.service';

const isExemptPath = (url: string): boolean => {
  const path = url.split('?')[0];
  if (path === '/login' || path === '/logout' || path.startsWith('/public/')) {
    return true;
  }

  if (path.startsWith('/wizards/runs/')) {
    return true;
  }

  return false;
};

export const wizardGateGuard: CanActivateChildFn = (_childRoute, state) => {
  if (currentAppScope() === 'admin') {
    return true;
  }

  const path = state.url.split('?')[0];
  if (isExemptPath(path)) {
    return true;
  }

  const wizardApi = inject(WizardApiService);
  const router = inject(Router);

  return wizardApi.getGate().pipe(
    map(run => {
      if (!run) {
        return true;
      }

      const target = `/wizards/runs/${run.id}`;
      if (path === target) {
        return true;
      }

      return router.parseUrl(target);
    }),
    catchError(() => of(true))
  );
};
